import type { ListFieldConfig } from '@ztechapps/common.hook'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'

export const blogListFieldConfig: ListFieldConfig = {
  title: {
    name: 'title',
    displayName: 'Title',
    defaultOnSearch: true,
    size: 350,
    index: 0,
  },
  slug: {
    name: 'slug',
    displayName: 'Slug',
    size: 220,
    index: 1,
  },
  summary: {
    name: 'summary',
    displayName: 'Summary',
    size: 620,
    index: 2,
  },
  tags: {
    name: 'tags',
    displayName: 'Tags',
    type: ListFieldTypeEnum.array,
    excludeOnSearch: true,
    size: 350,
    index: 3,
  },
  updatedAt: {
    name: 'updatedAt',
    displayName: 'Updated',
    type: ListFieldTypeEnum.dateTimeZone,
    excludeOnSearch: true,
    size: 180,
    index: 4,
  },
  status: {
    name: 'status',
    displayName: 'Status',
    excludeOnSearch: true,
    size: 120,
    index: 5,
  },
  _id: {
    name: '_id',
    isVisible: false,
  },
}
